<app-header4></app-header4>
<div class="page-title-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="banner-content mLText">
                    <span data-animation="fadeInLeft" data-delay="0.5s" class="bienVenu">BIENVENUE À L'ISN POLYSCIENCE</span>
                    <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title">DEPARTEMENT SCIENCES <br> DE LA SANTE</h1>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="services-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp paddCard" data-wow-duration=".1s" data-wow-delay=".3s">
                <div class="single-services text-center mt-30 c-marge">
                    <img src="assets/images/imagesAssets/infirmerSante.jpg" alt="">
                    <h4 class="title c-titleCard">SOINS INFIRMIERS ET OBSTETRIQUES</h4>
                    <hr class="c-hr">
                    <ul class="list-group">
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Infirmiers d’Etat</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Sages-femmes d’Etat</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Assistants infirmiers d’Etat</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Vendeur de pharmacie</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Secrétaire médicale</a></li>
                    </ul>
                    <a class="mainVoir" (click)="scrollToElement(soinsInfirmer)">Voir plus</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp paddCard" data-wow-duration=".5s" data-wow-delay=".4s">
                <div class="single-services single-services-2 text-center mt-30 c-marge">
                    <img src="assets/images/imagesAssets/biologieSante.jpg" alt="">
                    <h4 class="title c-titleCard">GENIE <br> BIOLOGIQUE</h4>
                    <hr class="c-hr">
                    <ul class="list-group">
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence Biologie médicale</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence Bio-informatique</a></li>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                    </ul>
                    <a class="mainVoir" (click)="admissionMaster('GENIE-BIOLOGIQUE')">Voir plus</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp paddCard" data-wow-duration="1s" data-wow-delay=".5s">
                <div class="single-services single-services-3 text-center mt-30 c-marge">
                    <img src="assets/images/imagesAssets/environnementSante2.jpg" alt="">
                    <h4 class="title c-titleCard">HYGIENE, SECURITE QUALITE, ENVIRONNEMENT</h4>
                    <hr class="c-hr">
                    <ul class="list-group">
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence Hygiène, Sécurité <br> et Environnement</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence Métiers de <br> la Qualité</a></li>
                        <br>
                        <br>
                        <br>
                        <br>
                    </ul>
                    <a class="mainVoir" (click)="scrollToElement(hygieneEnv)">Voir plus</a>
                </div>
            </div>
        </div>
    </div>
</div>



<!--====== ABOUT HISTORY PART START ======-->
<div class="about-history-area mtAboutA">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-8">
                <div class="section-title text-center">
                    <h2 class="title c-titleSoin">SOINS INFIRMIERS ET OBSTETRIQUES</h2>

                    <!-- <p>Does any industry face a more complex audience journey and marketing sales process than B2B technology.</p> -->
                </div>
            </div>
        </div>
        <div class="row" id="soinsInfirmer" #soinsInfirmer>
            <div class="col-lg-6 col-md-6">
                <div class="history-item  pt-240">
                    <div class="history-thumb wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".1s">
                        <img src="assets/images/imagesAssets/sageFemme.jpg" alt="history">
                    </div>
                    <div class="history-content wow fadeInUp c-pointer" data-wow-duration=".8s" data-wow-delay=".1s">
                        <span class="departe">DEPARTEMENT SCIENCES DE LA SANTE</span>
                        <h4 class="title" (click)="admissionMaster('SAGES-FEMMES')">SAGES-FEMMES D’ETAT.</h4>
                    </div>
                    <div class="number-box">
                        <span>02</span>
                    </div>
                </div>
                <div class="history-item">
                    <div class="history-thumb wow fadeInUp" data-wow-duration=".1s" data-wow-delay=".2s">
                        <img src="assets/images/imagesAssets/vendeurPharmacie.jpg" alt="history">
                    </div>
                    <div class="history-content wow fadeInUp c-pointer" data-wow-duration=".1s" data-wow-delay=".2s">
                        <span class="departe">DEPARTEMENT SCIENCES DE LA SANTE</span>
                        <h4 class="title">VENDEUR DE PHARMACIE.</h4>
                    </div>
                    <div class="number-box">
                        <span>03</span>
                    </div>
                    <!-- <div class="number-box-2">
                        <i class="fal fa-plus"></i>
                    </div> -->
                </div>


            </div>
            <div class="col-lg-6 col-md-6">

                <div class="history-item history-item-2">
                    <div class="history-thumb wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".1s">
                        <img src="assets/images/imagesAssets/inetat.jpg" alt="history">
                    </div>
                    <div class="history-content wow fadeInUp c-pointer" data-wow-duration=".8s" data-wow-delay=".1s">
                        <span class="departe">DEPARTEMENT SCIENCES DE LA SANTE</span>
                        <h4 class="title" (click)="admissionMaster('INFIRMIER')">INFIRMIERS D’ETAT.</h4>
                    </div>
                    <div class="number-box">
                        <span>01</span>
                    </div>
                </div>

                <div class="history-item history-item-2">
                    <div class="history-thumb wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".1s">
                        <img src="assets/images/imagesAssets/assistante.jpg" alt="history">
                    </div>
                    <div class="history-content wow fadeInUp c-pointer" data-wow-duration=".8s" data-wow-delay=".1s">
                        <span class="departe">DEPARTEMENT SCIENCES DE LA SANTE</span>
                        <h4 class="title">ASSISTANTS INFIRMIERS D’ETAT.</h4>
                    </div>
                    <div class="number-box">
                        <span>02</span>
                    </div>
                </div>
                <div class="history-item history-item-2">
                    <div class="history-thumb wow fadeInUp" data-wow-duration=".1s" data-wow-delay=".2s">
                        <img src="assets/images/imagesAssets/secretaireMedical.jpg" alt="history">
                    </div>
                    <div class="history-content wow fadeInUp c-pointer" data-wow-duration=".1s" data-wow-delay=".2s">
                        <span class="departe">DEPARTEMENT SCIENCES DE LA SANTE</span>
                        <h4 class="title">SECRÉTAIRE MÉDICALE.</h4>
                    </div>
                    <div class="number-box">
                        <span>04</span>
                    </div>
                </div>
            </div>



        </div>
        <!-- row -->
    </div>
    <!-- container -->
</div>

<!-- GENIE BIOLOGIQUE section  -->
<div class="about-experience-area pb-120">
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="experience-item">
                    <span class="c-de">DEPARTEMENT SCIENCES DE LA SANTE</span>
                    <h2 class="title c-biolo">GENIE BIOLOGIQUE.</h2>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1">
                <div class="experience-item">
                    <p class="c-TexteBio">
                        Le génie biologique désigne l'application des concepts et méthodes de la biologie (et accessoirement de la physique, chimie, mathématiques et informatique) afin de résoudre les problèmes relatifs aux sciences du vivant, en utilisant les méthodes analytiques
                        et de synthèses propres à l'ingénierie ainsi que son expérience quant au coût et à la faisabilité d'une solution.
                    </p>
                    <!-- <a routerLink='/about'>Read More</a> -->
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-6 col-sm-8 wow fadeInUp c-pointer" data-wow-duration=".5s" data-wow-delay=".2s" (click)="admissionMaster('GENIE-BIOLOGIQUE')">
                <div class="single-experience mt-30">
                    <img src="assets/images/imagesAssets/bioMeRe.jpg" alt="">
                    <div class="experience-overlay">
                        <h5 class="title">LICENCE BIOLOGIE MÉDICALE</h5>
                        <p>Le biologiste médical réalise et contrôle la réalisation d’actes de biologie médicale.</p>
                        <a routerLink='/service-detail'>Voir Plus</a>
                        <i class="fas fa-vial"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-8 wow fadeInUp c-pointer" data-wow-duration="1s" data-wow-delay=".4s" (click)="admissionMaster('GENIE-BIOLOGIQUE')">
                <div class="single-experience mt-30">
                    <img src="assets/images/imagesAssets/bio3Re.jpg" alt="">
                    <div class="experience-overlay">
                        <h5 class="title">LICENCE BIO-INFORMATIQUE</h5>
                        <p>Le bio-informaticien est un scientifique doté d'une double compétence en informatique et en biologie.</p>
                        <a routerLink='/service-detail'>Voir Plus</a>
                        <i class="fas fa-microscope"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="about-experience-area pb-120" id="hygieneEnv" #hygieneEnv>
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="experience-item">
                    <span class="c-de">DEPARTEMENT SCIENCES DE LA SANTE</span>
                    <h2 class="title c-biolo2">HYGIENE, SECURITE, QUALITE, ENVIRONNEMENT.</h2>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1">
                <div class="experience-item">
                    <p class="c-TexteBio">
                        La politique Qualité, Hygiène, Sécurité, Environnement (QHSE), Quality, Health, Safety and Environment en anglais, est un domaine d’expertise comprenant l’identification et le respect des normes de production d’une entreprise, avec une attention particulière
                        à l’environnement de travail des salariés, au matériel et au respect de l’environnement.
                    </p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-6 col-sm-8 wow fadeInUp c-pointer" data-wow-duration=".5s" data-wow-delay=".2s">
                <div class="single-experience mt-30">
                    <img src="assets/images/imagesAssets/qhRe.jpg" alt="">
                    <div class="experience-overlay">
                        <h5 class="title c-titreL">LICENCE HYGIÈNE, SÉCURITÉ ET ENVIRONNEMENT</h5>
                        <p>Hygiène, Sécurité et Environnement, vise la mise en œuvre et l’animation des démarches...</p>
                        <a routerLink=''>Voir Plus</a>
                        <!-- <i class="fas fa-vial"></i> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-8 wow fadeInUp c-pointer" data-wow-duration="1s" data-wow-delay=".4s">
                <div class="single-experience mt-30">
                    <img src="assets/images/imagesAssets/quali2Re.jpg" alt="">
                    <div class="experience-overlay">
                        <h5 class="title c-titreL">LICENCE MÉTIERS DE LA QUALITÉ</h5>
                        <p>La licence professionnelle mention Métiers de la qualité Parcours animateur qualité sécurité environnement...</p>
                        <a routerLink=''>Voir Plus</a>
                        <!-- <i class="fas fa-microscope"></i> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer2></app-footer2>